import CashierHistoryBody from "@/components/Cashier/CashierHistoryBody";
import PaginationControls from "@/components/PaginationControls";
import { Skeleton } from "@/components/ui/skeleton";
import { clearCashierOrdersSearchData } from "@/store/cashierOrdersSearchDataSlice";
import { CashierGroup, CashierOrderHistory, CashierOrderType } from "@/types/ApiTypes";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { RootState } from "@/store/store";
import PayLaterTableRow from "@/components/Cashier/PayLaterTableRow";
import GoBack from "@/components/GoBack";


export default function CashierHistory() {
    const { t } = useTranslation();
    const [cashierData, setCashierData] = useState<CashierOrderType[]>([]);
    const [pageNum, setPageNum] = useState(10);
    const [totalItems, setTotalItems] = useState(0)
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const cashierSearchData = useSelector((state: { cashierOrdersSearchData: { cashierOrdersSearchData: CashierOrderHistory; }; }) => state.cashierOrdersSearchData.cashierOrdersSearchData)
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const userData = useSelector((state: RootState) => state.user.userData)
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const locale = i18n.language
    const [refetch, setRefetch] = useState(false);
    async function geCashiertOrders(page: number) {
        setRefetch(false);
        setLoading(true);
        try {
            const response = await axios.get(`${baseUrl}/api/dashboard/cashier/orders?locale=${locale}`, {
                params: {

                    page: page,
                    length: pageNum,

                },
                headers: {
                    Authorization: token,
                },
            })
            if (response.data.success == true) {


                setCashierData(response.data.orders);
                setTotalItems(response.data.pagination.totalItems);
                setTotalPages(response.data.pagination.totalPages);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }


    const prevPageRef = useRef<number | null>(null);
    const prevPageNumRef = useRef<number | null>(null);
    const prevSearchDataRef = useRef<CashierOrderHistory | null>(null); // Use appropriate type if known

    useEffect(() => {
        const pageChanged = prevPageRef.current !== currentPage;
        const pageNumChanged = prevPageNumRef.current !== pageNum;
        const searchDataChanged = prevSearchDataRef.current !== cashierSearchData;

        if (!pageChanged && !pageNumChanged && !searchDataChanged) {
            return; // Nothing changed, do not re-call
        }

        if (cashierSearchData) {
            setCashierData([cashierSearchData]);
            setTotalItems(1);
            setTotalPages(1);
        } else {
            geCashiertOrders(currentPage);
        }

        // Update previous values
        prevPageRef.current = currentPage;
        prevPageNumRef.current = pageNum;
        prevSearchDataRef.current = cashierSearchData;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageNum, cashierSearchData]);

    useEffect(() => {
        if (refetch) {
            geCashiertOrders(currentPage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch]);
    if (loading) return (
        <>
            <div className="mt-10">
                <Skeleton className="w-full h-[500px] dark:bg-slate-600 dark:bg-opacity-35   rounded-md" />
            </div>
        </>
    )
    return (
        <>
            {cashierSearchData && <> <div className="w-full md:px-8 ">

                <button onClick={() => dispatch(clearCashierOrdersSearchData())} className=" px-5 mb-5 py-2 rounded-lg text-sidebar border-sidebar border-2 ms-auto flex items-center hover:bg-sidebar hover:text-skyblue transition-colors duration-200 gap-2">{t("cashierHistory.clearSearchData")}
                    <span className="text-xl text-red-500"><IoClose />
                    </span></button>
            </div></>}
          <GoBack />
            <div className=" overflow-x-auto whitespace-nowrap text-center">

                <table className="w-full text-sm  text-gray-500 bg-white ">
                    <thead className="text-xs text-gray-700 uppercase bg-white  ">
                        <tr className="border-b">



                            <th className="px-6 py-3 ">
                                {t("cashierHistory.clientName")}
                            </th>

                            <th className="px-6 py-3 ">
                                {t("cashierHistory.orderNumber")}
                            </th>
                            {userData?.role === "owner" || userData?.role === "superadmin" ? (
                                <th className="px-6 py-3 hidden md:table-cell">
                                    {t("orders.branch")}
                                </th>) : null}

                            <th scope="col" className="px-6 py-3 ">
                                {t("cashierHistory.orderedTime")}
                            </th>
                            <th scope="col" className="px-6 py-3 ">
                                {t("cashierHistory.paymentMethod")}
                            </th>
                            <th scope="col" className="px-6 py-3 ">
                                {t("orders.orderStatus")}
                            </th>
                            <th scope="col" className=" py-3 ">
                                {t("cashierHistory.invoiceStatus")}
                            </th>
                            <th scope="col" className="px-6 py-3 ">
                                {t("cashierHistory.totalPayment")}
                            </th>
                            <th scope="col" className="px-6 py-3">
                                {t("cashierHistory.actions")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cashierData.map((order, index) => (
                            order.type === "group" ? 
                            <PayLaterTableRow 
                            group={order as CashierGroup} 
                            key={index}
                            setRefetch={setRefetch}
                            />  
                            : 
                            <CashierHistoryBody key={index} order={order as CashierOrderHistory} setRefetch={setRefetch} />
                        ))}
                    </tbody>
                </table>
            </div >
            {!cashierSearchData &&
                <PaginationControls
                    pageNum={pageNum}
                    setPageNum={setPageNum}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages}
                />


            }

        </>
    )
}
